// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"db648a22","191":"c0599be1","360":"8d8b5ff4","396":"28bd07f1","572":"010a8dff","734":"fa2e0d00","893":"24e1a4a5"}[chunkId] + ".css";
};